import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Langs from "../../app/lang/langs";
import { formatDate } from "../../app/utils/helpers";
import { SelectInput } from "../../components/inputs/Select";
import { getHolidays, setSelectedYear } from "./settingsSlice";
import styles from "./Settings.module.css";
import SettingsPanelHeader from "../../components/settings/SettingsPanelHeader";
import SettingsEmptyState from "../../components/settings/SettingsEmptyState";

export default function HolidaysTab({ menuLabel }) {

  const dispatch = useDispatch()

  const settings = useSelector((state) => state.settings)

  const [selectedHolidaysCountry, setSelectedHolidaysCountry] = useState(1)

  function generateYearsOptions() {
    let options = []
    let now = new Date()
    let fromYear = now.getFullYear()
    for (let i = 2022; i < fromYear + 5; i++) {
      now.setFullYear(i)
      options.push({
        value: now.getFullYear(),
        label: now.getFullYear(),
      })
    }
    return options
  }

  const handleYearChange = (option) => {
    dispatch(setSelectedYear(option.value))
    dispatch(getHolidays({ year: option.value }))
  }

  const handleHolidaysCountryChange = (option) => {
    setSelectedHolidaysCountry(option.value)
  }

  const holidaysForSelectedYear =
    (settings.holidays[settings.selectedYear] &&
      settings.holidays[settings.selectedYear][selectedHolidaysCountry]) || []

  function renderHolidaysForSelectedYear() {
    if (!holidaysForSelectedYear.length) {
      return (
        <SettingsEmptyState
          icon="pi-calendar-times"
          title={<Langs str="SETTINGS_HOLIDAYS_EMPTY_TITLE" />}
          description={<Langs str="SETTINGS_HOLIDAYS_EMPTY_DESC" />}
        />
      )
    }

    return (
      <div className={styles.panelBody}>
        <div className={styles.listHeaderRow}>
          <span className={styles.listRowMain}>
            <Langs str="Jours férié" />
          </span>
          <span className={styles.listRowMeta}>
            <Langs str="Date" />
          </span>
        </div>
        {holidaysForSelectedYear.map((holiday) => {
          let date = new Date(holiday.date)
          return (
            <div className={styles.listRow} key={`HOLIDAY_${holiday.id || holiday.date}`}>
              <span className={styles.listRowMain}>
                <Langs str={holiday.title} />
              </span>
              <span className={styles.listRowMeta}>
                {formatDate(date, "dddd DD MMMM YYYY")}
              </span>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <Row className="m-0">
      <Col xxl={1}>
      </Col>
      <Col xxl={8} className="d-flex align-content-center">
        <div className={styles.menuContent}>
          <SettingsPanelHeader
            icon="pi-calendar"
            title={<Langs str={menuLabel} />}
            description={<Langs str="SETTINGS_HOLIDAYS_DESC" />}
            actions={
              holidaysForSelectedYear.length ? (
                <span className={styles.countBadge}>{holidaysForSelectedYear.length}</span>
              ) : null
            }
          />
          <div className={styles.filterBar}>
            <div className={styles.filterField}>
              <SelectInput
                value={selectedHolidaysCountry}
                onChange={handleHolidaysCountryChange}
                options={settings.countries}
              />
            </div>
            <div className={styles.filterField}>
              <SelectInput
                value={settings.selectedYear}
                onChange={handleYearChange}
                options={generateYearsOptions()}
              />
            </div>
          </div>
          {renderHolidaysForSelectedYear()}
        </div>
      </Col>
    </Row>
  )
}
